import download from 'downloadjs'
import * as htmlToImage from 'html-to-image'
import React, { ReactElement, ReactNode } from 'react'
import styled, { CSSProperties } from 'styled-components'
import watermark from 'watermarkjs'
import { AsyncButton } from '../buttons/Button'
import InputGroup from '../components/InputGroup'
import { alertError } from '../components/Notifications'
import colors from '../lib/colors'

const Styles = styled.div`
  border: 1px solid ${colors.darkGray};
  border-radius: 4px;
  padding: 15px;
  min-width: 280px;
  background-color: ${colors.white};
`
const Header = styled.div`
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`

const filterControls = ({ classList }: HTMLElement): boolean => {
  if (classList && classList.contains('widget-controls')) return false
  return true
}

interface IReportingWidgetProps {
  children: ReactNode
  className?: string
  title?: string | ReactElement
  controls?: ReactElement
  style?: CSSProperties
  downloadPng?: string
  logo?: ReactNode
}
export default function ReportingWidget(
  props: IReportingWidgetProps,
): ReactElement {
  const {
    children, className, title, controls, style, downloadPng, logo,
  } = props

  const addWatermark = async (dataURL: string): Promise<string | false> => {
    if (!logo) return false

    const res = await watermark([dataURL, logo]).image(
      watermark.image.upperRight(),
    )
    const canvas = document.createElement('canvas')
    canvas.width = res.width
    canvas.height = res.height
    const context = canvas.getContext('2d')

    if (!res || !context) return false

    context.drawImage(res, 0, 0)
    return canvas.toDataURL('image/png')
  }

  const downloadImage = async (): Promise<void> => {
    const container = document.getElementById(downloadPng || '')

    if (!downloadPng || !container) {
      alertError('Could not find image')
      return
    }

    const res = await htmlToImage.toPng(container, {
      filter: filterControls,
      pixelRatio: 2,
    })

    const watermarked = await addWatermark(res)

    if (!res || !watermarked) {
      alertError('Could not download image')
      return
    }

    download(watermarked, `${downloadPng}.png`)
  }

  const downloadButton = downloadPng ? (
    <AsyncButton onClick={downloadImage}>Download chart</AsyncButton>
  ) : null

  return (
    <Styles className={className} style={style} id={downloadPng}>
      {(logo || title || controls || downloadPng) && (
        <Header>
          <div>{title}</div>
          <div className="widget-controls">
            <InputGroup>
              {controls}
              {downloadButton}
            </InputGroup>
          </div>
        </Header>
      )}
      {children}
    </Styles>
  )
}
